export function stringFormat(sentence, words) {
    words.forEach(word => {
        sentence = sentence.replace(/_/, word);
    });
    return sentence;
}
